/**
 * Default Polish labels, used as-is by `react` (no i18next installed there).
 * `cyberjob_client` overrides this via a `labels` prop built from its own
 * `useTranslation("jobOffer")` adapter -- see the host app's integration code.
 */
const labels = {
    sectionTitle: "Ocena / Scoring",
    scoringEnabled: "Uwzględniaj w ocenie",
    summaryEnabled: "Ocena: włączona",
    summaryDisabled: "Ocena: wyłączona",
    summaryMax: (max) => `Max: ${max} pkt`,
    maxScore: "Maksymalna liczba punktów",
    description: "Opis (opcjonalnie)",
    missingPolicy: "Brak wartości",
    missingPolicyOptions: {
        IGNORE: "Brak wpływu",
        ENTITY_ZERO: "0 pkt za kryterium",
        TOTAL_ZERO: "0 pkt całego wyniku",
        DISQUALIFY: "Dyskwalifikacja",
    },
    scoringType: "Rodzaj oceny",
    scoringTypeOptions: {
        VALUE: "Konkretna wartość",
        SET: "Zbiór wartości",
        RANGE: "Przedziały liczbowe",
        AI_MATCH: "Ocena zgodności przez AI",
    },
    disqualify: "Dyskwalifikacja",
    valueRulesTitle: "Reguły punktacji",
    valueColumn: "Wartość",
    pointsColumn: "Punkty",
    disqualifyColumn: "Dyskwalifikuje",
    addValueRule: "+ Dodaj wartość",
    rangeFrom: "Od",
    rangeTo: "Do",
    addRangeRule: "+ Dodaj przedział",
    rangeOverlapError: "Ten przedział nakłada się z innym — popraw zakresy przed zapisem.",
    setAggregation: "Sposób agregacji",
    setAggregationOptions: {
        SUM_VALUES: "Sumuj punkty wartości",
        MATCH_COUNT: "Punktuj liczbę trafień",
    },
    capAtMaxScore: "Ogranicz wynik do maksymalnej liczby punktów",
    addSetRule: "+ Dodaj wartość",
    aiCriterion: "Kryterium / oczekiwana odpowiedź",
    aiCriterionPlaceholder: "Opisz, czego oczekujesz od odpowiedzi kandydata...",
    aiLevelsTitle: "Poziomy zgodności i punktacja",
    aiLevelColumn: "Poziom zgodności",
    aiLevelOptions: {
        FULL_MATCH: "Pełna zgodność",
        HIGH_MATCH: "Wysoka zgodność",
        PARTIAL_MATCH: "Częściowa zgodność",
        LOW_MATCH: "Niska zgodność",
        NO_MATCH: "Brak zgodności",
        UNKNOWN: "Nieznany",
    },
    addAiLevel: "+ Dodaj poziom",
    remove: "Usuń",
    sourceScenario: "Źródło konfiguracji: Scenariusz",
    sourceScenarioLocked: "Ta konfiguracja jest zablokowana przez administratora scenariusza.",
    sourceRecruitment: "Źródło konfiguracji: Ta rekrutacja",
    customizeForRecruitment: "Dostosuj dla tej rekrutacji",
    overrideModeLabel: "Możliwość nadpisania przez klienta",
    overrideModeOptions: {
        LOCKED: "Zablokowane (LOCKED)",
        ALLOW_RECRUITMENT_OVERRIDE: "Klient może dostosować",
    },
    noEvaluation: "Brak oceny",
    bucketRecommended: "Rekomendowany",
    bucketToReview: "Do analizy",
    bucketLow: "Niskie dopasowanie",
    bucketVeryLow: "Bardzo niskie",
    bucketDisqualified: "Zdyskwalifikowany",
    bucketNeedsReview: "Wymaga ręcznej analizy",
};

export default labels;
